import { useDispatch } from "react-redux";
import {
  setSelectedPipeline,
  setSelectedVideoHome,
} from "../../redux/slice/videoSlice";
import { Button } from "antd";
import NewPlayGround from "./NewPlayGround";
function Step1({ setClickUpload }) {
  const dispatch = useDispatch();
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
        }}
      >
        <Button
          onClick={() => {
            setClickUpload(false);
            dispatch(setSelectedPipeline({}));
            dispatch(setSelectedVideoHome(null));
          }}
          type="primary"
        >
          Connect Camera
        </Button>
      </div>
      <NewPlayGround />
    </div>
  );
}

export default Step1;
